import React, { FC, memo, useCallback, useEffect, useState } from 'react'

import { ContentUnavailable } from '@/components/ContentUnavailable/ContentUnavailable'
import { MatchPage } from '@/components/DataWidget/components/MatchPage'
import { dataWidgetTypes } from '@/constants/common'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { DataWidgetTypeProps } from '@/types/componentsPropsTypes'
import { StatsPerformType } from '@/types/servicesTypes'

import { Commentary } from './components/Commentary'
import { Matches } from './components/Matches'
import { Standings } from './components/Standings'
import { ContentUnavailableWrapper, DataWidgetElem } from './styles'

const DataWidgetRaw: FC<DataWidgetTypeProps> = ({
  dataWidget,
  isPopup,
  match,
  dataExtension,
}) => {
  const { t } = useCommonTranslation()
  const [statsPerform, setStatsPerform] =
    useState<Nullable<StatsPerformType>>(null)

  useEffect(() => {
    const statsPerform = dataWidget.statsPerform
    if (statsPerform) {
      setStatsPerform(statsPerform)
    } else if (dataExtension) {
      const updatedStatsPerform = {
        competitionId: dataExtension.competitionId,
        tournamentCalendarId: dataExtension.seriesId,
        contestantId: dataExtension.teamId,
      }
      setStatsPerform(updatedStatsPerform)
    } else {
      setStatsPerform({})
    }
  }, [dataWidget, dataExtension])

  const renderContent = useCallback(() => {
    if (!statsPerform) {
      return
    }
    const dataWidgetType = dataWidget.type

    switch (dataWidgetType) {
      case dataWidgetTypes.STANDINGS:
        return (
          <Standings
            isPopup={isPopup}
            tournamentCalendarId={statsPerform.tournamentCalendarId}
          />
        )

      case dataWidgetTypes.MATCH:
        return (
          <MatchPage
            match={match}
            commentaryType={statsPerform.commentary?.type}
          />
        )

      case dataWidgetTypes.MATCHES:
        return (
          <Matches
            key={`${statsPerform.contestantId}-${statsPerform.tournamentCalendarId}`}
            contestantId={statsPerform.contestantId}
            tournamentCalendarId={statsPerform.tournamentCalendarId}
          />
        )

      case dataWidgetTypes.COMMENTARY:
        return (
          <Commentary
            contestantId={statsPerform.contestantId}
            tournamentCalendarId={statsPerform.tournamentCalendarId}
            commentaryType={statsPerform.commentary?.type}
          />
        )

      default:
        return (
          <ContentUnavailableWrapper>
            <ContentUnavailable>
              {t('dataWidgetTypeUnavailable', { dataWidgetType })}
            </ContentUnavailable>
          </ContentUnavailableWrapper>
        )
    }
  }, [dataWidget, statsPerform])

  return <DataWidgetElem>{statsPerform && renderContent()}</DataWidgetElem>
}

export const DataWidget = memo(DataWidgetRaw)
